import { CurrenciesActionType } from '@redux/reducers/currencies/enum';

import Api from '@api/index';

import { Currency } from '@shared/interfaces/currency';

export const loadCurrencies = (currencies: Currency[]) => {
  return {
    type: CurrenciesActionType.LoadCurrencies,
    payload: currencies,
  };
};

export const getCurrencies = () => async dispatch => {
  let currencies: Currency[] = [];

  try {
    currencies = await Api.getCurrencies();
  } catch {
    console.error('getCurrencies failed');
  }

  dispatch(loadCurrencies(currencies));
};
